/*
 * File: index.js
 * Project: mp-mobile-app
 *
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description:
 * HOC for the patient alerts page
 */
import React from "react";
import Alerts from "./views/Alerts";

const Index = () => {
  return <Alerts />;
};

export default Index;
